import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import SendEmailService from "@/services/SendEmailService";
import AdminNavigation from "../../AdminNavigationContainer.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import UserInfoDataService from "@/services/UserInfoDataService";
import i18n from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const userId = ref("");
const username = ref("");
const email = ref("");
const menuTile = ref("Password Reset/Initialize Request");

const alertmessage = ref("null");
const alertstate = ref("neutral");

const isLoading = ref(false);

const sendEmail = () => {
  alertmessage.value = "null";
  alertstate.value = "neutral";

  SendEmailService.sendResetEmail({
    data: {
      enteredId: userId.value,
      stationCode: store.getters.stationCode,
      userId: store.getters.cognitoUserName,
      givenName: store.getters.givenName,
      familyName: store.getters.familyName,
      address: email.value,
      userMail: store.getters.email,
      isSend: false,
    },
  })
    .then((response: ResponseData) => {
      var userData = response.data.userData;
      const csvfileData1 = {
        actionFlg: "99",
        userID: userData[0].userId,
        LName: userData[0].familyName,
        FName: userData[0].givenName,
        employeeID: userData[0].employeeNumber,
        mail: userData[0].email,
        companyName:userData[0].stationCode.companyName,
        stationCode: userData[0].stationCode.stationCode,
        targetScreen: "PwdResetRequest"
      };
      UserInfoDataService.send_authenticationID(csvfileData1)
        .then((resData: ResponseData) => {
          if(resData.data.message != undefined){
            alertmessage.value = resData.data.message;
            alertstate.value = "error";
          }else{
            alertmessage.value = response.data.message;
            alertstate.value = "success";
          }
          isLoading.value = false;
        })
        .catch((e: Error) => {
          alertmessage.value = i18n.t("err063");
          alertstate.value = "error";
          console.log(e);
        });
    })
    .catch((error: ResponseData) => {
      alertmessage.value = error.response.data;
      alertstate.value = "error";
      isLoading.value = false;
    });
};

const __returned__ = { userId, username, email, menuTile, alertmessage, alertstate, isLoading, sendEmail, AdminNavigation, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})